// Testimonials Slider - Josep CC
document.addEventListener('DOMContentLoaded', function() {
    const testimonialsSliders = document.querySelectorAll('.testimonials-slider');
    
    testimonialsSliders.forEach(function(slider) {
        initTestimonialsSlider(slider);
    });
});

function initTestimonialsSlider(slider) {
    const testimonials = slider.querySelectorAll('.testimonial-item');
    const prevBtn = slider.querySelector('.slider-prev');
    const nextBtn = slider.querySelector('.slider-next');
    const dots = slider.querySelectorAll('.slider-dot');
    
    if (testimonials.length === 0) return;
    
    let currentIndex = 0;
    let intervalId = null;
    
    // Initialize
    showTestimonial(0);
    
    // Auto-play functionality
    function startAutoPlay() {
        intervalId = setInterval(function() {
            nextTestimonial();
        }, 5000); // Change every 5 seconds
    }
    
    function stopAutoPlay() {
        if (intervalId) {
            clearInterval(intervalId);
            intervalId = null;
        }
    }
    
    function showTestimonial(index) {
        // Hide all testimonials
        testimonials.forEach(function(testimonial) {
            testimonial.classList.remove('active');
        });
        
        // Remove active class from all dots
        dots.forEach(function(dot) {
            dot.classList.remove('active');
        });
        
        // Show current testimonial
        if (testimonials[index]) {
            testimonials[index].classList.add('active');
            currentIndex = index;
        }
        
        // Highlight current dot
        if (dots[index]) {
            dots[index].classList.add('active');
        }
    }
    
    function nextTestimonial() {
        const nextIndex = (currentIndex + 1) % testimonials.length;
        showTestimonial(nextIndex);
    }
    
    function prevTestimonial() {
        const prevIndex = (currentIndex - 1 + testimonials.length) % testimonials.length;
        showTestimonial(prevIndex);
    }
    
    // Event listeners for navigation buttons
    if (prevBtn) {
        prevBtn.addEventListener('click', function() {
            prevTestimonial();
            stopAutoPlay();
            startAutoPlay(); // Restart auto-play
        });
    }
    
    if (nextBtn) {
        nextBtn.addEventListener('click', function() {
            nextTestimonial();
            stopAutoPlay();
            startAutoPlay(); // Restart auto-play
        });
    }
    
    // Event listeners for dots
    dots.forEach(function(dot, index) {
        dot.addEventListener('click', function() {
            showTestimonial(index);
            stopAutoPlay();
            startAutoPlay(); // Restart auto-play
        });
    });
    
    // Keyboard navigation
    slider.addEventListener('keydown', function(e) {
        if (e.key === 'ArrowLeft') {
            e.preventDefault();
            prevTestimonial();
            stopAutoPlay();
            startAutoPlay();
        } else if (e.key === 'ArrowRight') {
            e.preventDefault();
            nextTestimonial();
            stopAutoPlay();
            startAutoPlay();
        }
    });
    
    // Pause on hover
    slider.addEventListener('mouseenter', function() {
        stopAutoPlay();
    });
    
    slider.addEventListener('mouseleave', function() {
        startAutoPlay();
    });
    
    // Pause when page is not visible
    document.addEventListener('visibilitychange', function() {
        if (document.hidden) {
            stopAutoPlay();
        } else {
            startAutoPlay();
        }
    });
    
    // Touch/swipe support for mobile
    let startX = 0;
    let endX = 0;
    
    slider.addEventListener('touchstart', function(e) {
        startX = e.touches[0].clientX;
        stopAutoPlay();
    }, { passive: true });
    
    slider.addEventListener('touchend', function(e) {
        endX = e.changedTouches[0].clientX;
        handleSwipe();
        startAutoPlay();
    }, { passive: true });
    
    function handleSwipe() {
        const swipeThreshold = 50;
        const diff = startX - endX;
        
        if (Math.abs(diff) > swipeThreshold) {
            if (diff > 0) {
                // Swiped left - go to next
                nextTestimonial();
            } else {
                // Swiped right - go to previous
                prevTestimonial();
            }
        }
    }
    
    // Start auto-play initially
    startAutoPlay();
    
    // Accessibility improvements
    slider.setAttribute('role', 'region');
    slider.setAttribute('aria-label', 'Testimonios de usuarios');
    
    testimonials.forEach(function(testimonial, index) {
        testimonial.setAttribute('role', 'tabpanel');
        testimonial.setAttribute('aria-label', `Testimonio ${index + 1} de ${testimonials.length}`);
    });
    
    dots.forEach(function(dot, index) {
        dot.setAttribute('role', 'tab');
        dot.setAttribute('aria-controls', `testimonial-${index}`);
    });
}